import { ReactNode } from 'react';

/** トップの各セクション見出し（eyebrow + display-md）。右側にリンク等を置ける */
const SectionHeader = ({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow: string;
  title: ReactNode;
  description?: string;
  action?: ReactNode;
}) => (
  <div className="flex items-end justify-between mb-10 sm:mb-14 gap-6">
    <div>
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h2 className="display-md text-ink">{title}</h2>
      {description && (
        <p className="mt-3 text-body text-ink-subtle max-w-2xl">
          {description}
        </p>
      )}
    </div>
    {action}
  </div>
);

export default SectionHeader;
